import { useAuthStore } from '@/stores/auth';

/**
 * RC-065: `useTenantTimezone()` (grade, formulário, "já passou", carimbos) lê
 * `user.tenant.settings` do store de sessão, que só era preenchido no login. Trocar o fuso em
 * Configurações deixava a aba 1 h fora do servidor até a pessoa entrar de novo. Este é o único
 * caminho para atualizar esse retrato — a aba que salvou e as outras (evento `settings:updated`).
 * Devolve false quando não há sessão para atualizar.
 */
export function applyTenantSettingsToSession(settings: Record<string, unknown> | null | undefined): boolean {
  if (!settings || typeof settings !== 'object') return false;
  const { user, setUser } = useAuthStore.getState();
  if (!user?.tenant) return false;
  setUser({ ...user, tenant: { ...user.tenant, settings } });
  return useAuthStore.getState().user?.tenant?.settings === settings;
}

/**
 * Story 67.8 — o nome da clínica mudou (`Tenant.name`). O seletor de clínica do topo e a lista
 * do Perfil leem `user.tenant` e `user.clinics`, preenchidos no login; sem isto ficavam com o
 * nome antigo até entrar de novo (RC-065).
 */
export function applyClinicNameToSession(tenantId: string | null | undefined, name: unknown): boolean {
  if (!tenantId || typeof name !== 'string' || !name) return false;
  const { user, setUser } = useAuthStore.getState();
  if (!user) return false;
  const tenant = user.tenant?.id === tenantId ? { ...user.tenant, name } : user.tenant;
  const clinics = user.clinics?.map((clinic) => (clinic.id === tenantId ? { ...clinic, name } : clinic));
  const next = { ...user, tenant, clinics };
  setUser(next);
  return useAuthStore.getState().user === next;
}
